import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { ActiveSupplierQuoteFragmentDoc } from './ActiveSupplierQuote.generated'
import { AdvancedBestBuyLineFragmentDoc } from './AdvancedBestBuyLine.generated'
import { AdvancedPrLineMoreOptionLineFragmentDoc } from './AdvancedPRLineMoreOptionLine.generated'
import { AdvancedPrLineQuantityLineFragmentDoc } from './AdvancedPRLineQuantityLine.generated'
import { AdvancedPrLineTaxPercentageLineFragmentDoc } from './AdvancedPRLineTaxPercentageLine.generated'
import { AdvancedPrLineUnitPriceLineFragmentDoc } from './AdvancedPRLineUnitPriceLine.generated'
import { ProductCardLocationQuantityLineFragmentDoc } from './ProductCardLocationQuantityLine.generated'
import { ProductItemProductFragmentDoc } from './ProductItemProduct.generated'
import { ProductItemSupplierFragmentDoc } from './ProductItemSupplier.generated'
import { QuotesButtonLineFragmentDoc } from './QuotesButtonLine.generated'
import { RequisitionLineExtraLineItemLineFragmentDoc } from './RequisitionLineExtraLineItemLine.generated'
import { RequisitionLineOptionsLineFragmentDoc } from './RequisitionLineOptionsLine.generated'
import { SupplierSelectorButtonLineFragmentDoc } from './SupplierSelectorButtonLine.generated'
import * as Types from './purchasePlus_graphql'

export const AdvancedShopProductListLineFragmentDoc = gql`
  fragment AdvancedShopProductListLine on RequisitionLine {
    id
    uuid
    purchaserProductCode
    supplierProductCode
    unitTax
    total
    department {
      id
      name
    }
    account {
      id
      code
      codedName
    }
    supplier {
      id
      name
      ...ProductItemSupplier
    }
    product {
      id
      concatenatedSellUnit
      category {
        id
        name
        parent {
          id
          name
        }
      }
      ...ProductItemProduct
    }
    availableQuotes {
      unitPrice
      ...ActiveSupplierQuote
    }
    ...QuotesButtonLine
    ...AdvancedBestBuyLine
    ...RequisitionLineExtraLineItemLine
    ...ProductCardLocationQuantityLine
    ...SupplierSelectorButtonLine
    ...RequisitionLineOptionsLine
    ...AdvancedPrLineUnitPriceLine
    ...AdvancedPrLineTaxPercentageLine
    ...AdvancedPrLineQuantityLine
    ...AdvancedPrLineMoreOptionLine
  }
  ${ProductItemSupplierFragmentDoc}
  ${ProductItemProductFragmentDoc}
  ${ActiveSupplierQuoteFragmentDoc}
  ${QuotesButtonLineFragmentDoc}
  ${AdvancedBestBuyLineFragmentDoc}
  ${RequisitionLineExtraLineItemLineFragmentDoc}
  ${ProductCardLocationQuantityLineFragmentDoc}
  ${SupplierSelectorButtonLineFragmentDoc}
  ${RequisitionLineOptionsLineFragmentDoc}
  ${AdvancedPrLineUnitPriceLineFragmentDoc}
  ${AdvancedPrLineTaxPercentageLineFragmentDoc}
  ${AdvancedPrLineQuantityLineFragmentDoc}
  ${AdvancedPrLineMoreOptionLineFragmentDoc}
` as unknown as DocumentNode<Types.AdvancedShopProductListLineFragment, unknown>
